import { act } from 'react-dom/test-utils';
export function nextSlice(callback) {
  if (process.env.NODE_ENV === 'test') {
    Promise.resolve().then(function () {
      act(function () {
        callback();
      });
    });
  } else {
    /* istanbul ignore next */
    Promise.resolve().then(callback);
  }
}